import { Controller } from "@hotwired/stimulus"

// Email content viewer controller for managing tabs and preview modes
export default class extends Controller {
  static targets = ["tab", "content", "htmlIframe", "htmlSource"]

  connect() {
    // Set controller reference for global functions
    this.element.emailContentController = this
  }

  showContent(event) {
    const contentType = event.target.dataset.contentTarget
    
    // Update tab styles
    this.tabTargets.forEach(tab => {
      if (tab.dataset.contentTarget === contentType) {
        tab.classList.remove("border-transparent", "text-gray-500")
        tab.classList.add("border-indigo-500", "text-indigo-600")
      } else {
        tab.classList.add("border-transparent", "text-gray-500")
        tab.classList.remove("border-indigo-500", "text-indigo-600")
      }
    })

    // Show/hide content sections
    this.contentTargets.forEach(content => {
      if (content.id === `${contentType}-content`) {
        content.style.display = "block"
      } else {
        content.style.display = "none"
      }
    })
  }

  // Method for programmatic content switching (for backward compatibility)
  showContentType(contentType) {
    // Update tab styles
    this.tabTargets.forEach(tab => {
      if (tab.dataset.contentTarget === contentType) {
        tab.classList.remove("border-transparent", "text-gray-500")
        tab.classList.add("border-indigo-500", "text-indigo-600")
      } else {
        tab.classList.add("border-transparent", "text-gray-500")
        tab.classList.remove("border-indigo-500", "text-indigo-600")
      }
    })

    // Show/hide content sections
    this.contentTargets.forEach(content => {
      if (content.id === `${contentType}-content`) {
        content.style.display = "block"
      } else {
        content.style.display = "none"
      }
    })
  }

  togglePreviewMode() {
    const htmlPreview = this.element.querySelector("#html-preview")
    const htmlSource = this.element.querySelector("#html-source")
    
    if (htmlPreview && htmlSource) {
      if (htmlPreview.classList.contains("hidden")) {
        htmlPreview.classList.remove("hidden")
        htmlSource.classList.add("hidden")
      } else {
        htmlPreview.classList.add("hidden")
        htmlSource.classList.remove("hidden")
      }
    }
  }

  downloadContent(event) {
    const contentType = event.params.type
    const emailId = event.params.emailId
    
    // Get the content based on type
    let content = ""
    let filename = `email_${emailId}`
    let mimeType = "text/plain"
    
    if (contentType === "html") {
      const iframe = this.element.querySelector("#html-iframe")
      if (iframe && iframe.srcdoc) {
        content = iframe.srcdoc
        filename += ".html"
        mimeType = "text/html"
      }
    } else if (contentType === "text") {
      const textElement = this.element.querySelector("#text-content pre")
      if (textElement) {
        content = textElement.textContent
        filename += ".txt"
      }
    }
    
    if (content) {
      this.downloadFile(content, filename, mimeType)
    }
  }

  downloadFile(content, filename, mimeType) {
    const blob = new Blob([content], { type: mimeType })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    
    link.href = url
    link.download = filename
    link.style.display = 'none'
    
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    
    URL.revokeObjectURL(url)
  }
}

// Global functions for backward compatibility with onclick handlers
window.showEmailContent = function(contentType) {
  const controller = document.querySelector('[data-controller~="email-content"]')
  if (controller && controller.emailContentController) {
    controller.emailContentController.showContentType(contentType)
  }
}

window.toggleEmailFrame = function(contentType) {
  const controller = document.querySelector('[data-controller~="email-content"]')
  if (controller && controller.emailContentController) {
    controller.emailContentController.togglePreviewMode()
  }
}

window.downloadEmailContent = function(contentType, emailId) {
  const controller = document.querySelector('[data-controller~="email-content"]')
  if (controller && controller.emailContentController) {
    controller.emailContentController.downloadContent({
      params: { type: contentType, emailId: emailId }
    })
  }
}
